import * as React from "react";
import clsx from "clsx";
import { head } from "lodash";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { getMonthName, getYear } from "../../utils/date";
import DatePickerDay from "./DatePickerDay";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  wrapper: {
    marginTop: typography.pxToRem(29),
    display: "inline-block"
  },
  dayContainer: {
    marginTop: typography.pxToRem(29)
  },
  title: {
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(14),
      marginLeft: typography.pxToRem(5)
    },
    [breakpoints.up("sm")]: {
      fontSize: typography.pxToRem(19),
      marginLeft: typography.pxToRem(10)
    },
    fontWeight: "normal",
    lineHeight: 0.84,
    letterSpacing: 0.41,
    color: palette.text.hintSecondary
  }
}));

const DatePicker = ({
  dates,
  selectedDate,
  onSelect,
  classes = {}
}) => {
  const styles = useStyles();
  const dayForTitle = selectedDate || head(dates);
  const month = getMonthName(dayForTitle);
  const year = getYear(dayForTitle);
  return /*#__PURE__*/React.createElement(Grid, {
    className: styles.wrapper,
    "data-testid": "date-picker"
  }, dates.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title,
    "data-testid": "date-picker-title"
  }, `${month} ${year}`.toUpperCase()), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "center",
    alignItems: "flex-start",
    className: clsx(styles.dayContainer, classes.dayContainer),
    "data-testid": "date-picker-day-container"
  }, dates.map((el, i) => {
    return /*#__PURE__*/React.createElement(DatePickerDay, {
      key: i,
      day: el,
      onSelect: onSelect,
      setActiveDay: onSelect,
      isActive: el === selectedDate
    });
  }))) : /*#__PURE__*/React.createElement(Typography, {
    className: styles.title
  }, "There are no available dates"));
};

export default DatePicker;